<div class="flex flex--column g-medium">
  <h2 class="nordic-blue-900-text text-icon-primary font-heading-4 font-title-medium" data-testid="hotel-title">
    {{ 'bookingWidgetTabs.hotels.title' | finLocalization }}
  </h2>

  <div class="poweredby flex flex--middle">
    <span class="ms-xsmall-r">{{ 'bookingWidgetTabs.hotels.poweredBy' | finLocalization }}</span>
    <div class="rounded-large" [ngClass]="{ 'surface-static-light ps-xsmall-x ps-xxsmall-y': isDarkTheme() }">
      <fcom-icon class="logo" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.HOTELS_LOGO" />
    </div>
  </div>

  <fin-location-selector
    [singleLocation]="true"
    [originLabel]="'bookingWidgetTabs.hotels.destination' | finLocalization"
    [originPlaceholder]="'bookingWidgetTabs.hotels.destinationPlaceholder' | finLocalization"
    [originSearchPlaceholder]="'bookingWidgetTabs.hotels.destinationSearchPlaceholder'"
    [airportsOnly]="false"
    [skipDefaultOriginFetch]="false"
    [showSuggestedDestinations]="true"
    [showLocateMe]="true"
    [showPreviousSearches]="false"
    [locationPair]="{ origin: form.destination().value() ?? undefined }"
    (setLocations)="onDestinationSelected($event)"
  />

  @if (form.destination().value()) {
    <div class="fields g-small">
      <div class="datetime-group">
        <fin-booking-widget-selector
          [label]="'bookingWidgetTabs.hotels.checkInDate' | finLocalization"
          [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
          [ariaLabel]="'bookingWidgetTabs.hotels.checkInDate' | finLocalization"
          [filled]="!!checkInLocalDate()"
          [position]="'left'"
          (click)="openDateModal('checkIn')"
          data-testid="hotel-checkin-date-selector"
        >
          @if (checkInLocalDate(); as date) {
            <span>{{ date | finDateFormat: 'FULL_NO_YEAR' }}</span>
          }
        </fin-booking-widget-selector>

        <fin-booking-widget-selector
          [label]="'bookingWidgetTabs.hotels.checkOutDate' | finLocalization"
          [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
          [ariaLabel]="'bookingWidgetTabs.hotels.checkOutDate' | finLocalization"
          [filled]="!!checkOutLocalDate()"
          [position]="'right'"
          (click)="openDateModal('checkOut')"
          data-testid="hotel-checkout-date-selector"
        >
          @if (checkOutLocalDate(); as date) {
            <span>{{ date | finDateFormat: 'FULL_NO_YEAR' }}</span>
          }
        </fin-booking-widget-selector>
      </div>

      <fin-guests-and-rooms-selector (setRooms)="onRoomsChange($event)" />
    </div>

    <div class="flex flex--end">
      <fcom-button
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [size]="ButtonSize.LARGE"
        [mode]="ButtonMode.FILL"
        [text]="'bookingWidgetTabs.hotels.ctaButton' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
        [disabled]="form().valid() === false"
        (clickBtn)="onSearch()"
        data-testid="hotel-search-button"
      />
    </div>
  }

  <fcom-notification [layout]="NotificationLayout.BLOCK" [iconName]="SvgLibraryIcon.AVIOS_CURRENCY">
    <p class="medium-type">
      {{ 'bookingWidgetTabs.hotels.aviosNotification' | finLocalization }}
    </p>
  </fcom-notification>
</div>

<fcom-modal
  [open]="datesModalOpen"
  [fitToContent]="true"
  [buttons]="null"
  [fullHeight]="true"
  [extraWide]="true"
  [roundedContent]="true"
  (close)="closeDatesModal()"
  data-testid="hotel-dates-modal"
>
  <fcom-datepicker
    [uiLabels]="datepickerLabels$ | async"
    [dateLabels]="dateLabels$ | async"
    [isDateRange]="true"
    [selectableDatesRange]="datepickerRange()"
    [selectedDates]="datepickerSelectedDates()"
    [showTags]="false"
    (selectedDatesChange)="updateDates($event)"
    (close)="closeDatesModal()"
  />
</fcom-modal>
